export default {
  name: 'text',
  component_path: 'modules/procedures/blocks/static/BlockText'
}